import type { ComponentProps } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import { cn } from "../../lib/utils";
import { OverlayLayerProvider, useOverlayZIndex } from "../../lib/overlay-z-index";

export const DropdownMenuContent = ({
  className,
  sideOffset = 4,
  style: styleProp,
  ...props
}: ComponentProps<typeof DropdownMenuPrimitive.Content>) => {
  // Nesting-aware z-index: a dropdown inside a dialog stacks above it; a dialog opened from this
  // dropdown starts a fresh stack above the dropdown.
  const { z, style, className: zClassName } = useOverlayZIndex("dropdown");

  return (
    <DropdownMenuPrimitive.Portal>
      <OverlayLayerProvider base={z}>
        <DropdownMenuPrimitive.Content
          data-slot="dropdown-menu-content"
          sideOffset={sideOffset}
          // Merge, so a caller passing `style` can't clobber the `--z` custom property that drives
          // nesting-aware stacking.
          style={{ ...style, ...styleProp }}
          className={cn(
            "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
            zClassName,
            className
          )}
          {...props}
        />
      </OverlayLayerProvider>
    </DropdownMenuPrimitive.Portal>
  );
};
